"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserProfilingIntegration = void 0;

var _core = require("@sentry/core");

var _debugBuild = require("../debug-build.js");

var _startProfileForSpan = require("./startProfileForSpan.js");

var _utils = require("./utils.js");

const INTEGRATION_NAME = 'BrowserProfiling';

const _browserProfilingIntegration = () => {
  return {
    name: INTEGRATION_NAME,

    setup(client) {
      const activeSpan = (0, _core.getActiveSpan)();
      const rootSpan = activeSpan && (0, _core.getRootSpan)(activeSpan);

      if (rootSpan && (0, _utils.isAutomatedPageLoadSpan)(rootSpan)) {
        if ((0, _utils.shouldProfileSpan)(rootSpan)) {
          (0, _startProfileForSpan.startProfileForSpan)(rootSpan);
        }
      }

      client.on('spanStart', span => {
        if (span === (0, _core.getRootSpan)(span) && (0, _utils.shouldProfileSpan)(span)) {
          (0, _startProfileForSpan.startProfileForSpan)(span);
        }
      });
      client.on('beforeEnvelope', envelope => {
        // if not profiles are in queue, there is nothing to add to the envelope.
        if (!(0, _utils.getActiveProfilesCount)()) {
          return;
        }

        const profiledTransactionEvents = (0, _utils.findProfiledTransactionsFromEnvelope)(envelope);

        if (!profiledTransactionEvents.length) {
          return;
        }

        const profilesToAddToEnvelope = [];

        for (const profiledTransaction of profiledTransactionEvents) {
          const context = profiledTransaction && profiledTransaction.contexts;
          const profile_id = context && context['profile'] && context['profile']['profile_id'];
          const start_timestamp = context && context['profile'] && context['profile']['start_timestamp'];

          if (typeof profile_id !== 'string') {
            _debugBuild.DEBUG_BUILD && _core.logger.log('[Profiling] cannot find profile for a span without a profile context');
            continue;
          }

          if (!profile_id) {
            _debugBuild.DEBUG_BUILD && _core.logger.log('[Profiling] cannot find profile for a span without a profile context');
            continue;
          } // Remove the profile from the span context before sending, relay will take care of the rest.


          if (context && context['profile']) {
            delete context.profile;
          }

          const profile = (0, _utils.takeProfileFromGlobalCache)(profile_id);

          if (!profile) {
            _debugBuild.DEBUG_BUILD && _core.logger.log(`[Profiling] Could not retrieve profile for span: ${profile_id}`);
            continue;
          }

          const profileEvent = (0, _utils.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);

          if (profileEvent) {
            profilesToAddToEnvelope.push(profileEvent);
          }
        }

        (0, _utils.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
      });
    }

  };
};

const browserProfilingIntegration = exports.browserProfilingIntegration = (0, _core.defineIntegration)(_browserProfilingIntegration);